module.exports = __webpack_public_path__ + "img/australia-genitourinary-diseases-male.a65a5168.png";